import React, { useEffect, useState } from "react";

import { ensureAppSettings } from "../services/data";

//const RELATIONS_LS_KEY = 'relations_settings'
//const DOSSIERS_LS_KEY = 'dossiers_settings'

const DEFAULT_RELATIONS = {
  main: { label: "Relations", icon: "fas fa-address-book", defaultOpen: true },
  types: [
    { label: "Clients", icon: "fas fa-user-tie", key: "client", visible: true },
    {
      label: "Fournisseurs",
      icon: "fas fa-truck",
      key: "fournisseur",
      visible: true,
    },
  ],
};

const DEFAULT_DOSSIERS = {
  main: { label: "Dossiers", icon: "fas fa-folder", defaultOpen: true },
  types: [
    {
      label: "Dossier des contrats",
      icon: "fas fa-file-contract",
      key: "contrats",
      visible: true,
    },
    {
      label: "Dossier des factures",
      icon: "fas fa-file-invoice",
      key: "factures",
      visible: true,
    },
  ],
};

export default function Sidebar({
  user,
  currentPage = "dashboard",
  onNavigate = () => {},
  open = false,
}) {

  const [isRelationsOpen, setIsRelationsOpen] = useState(false);
  const [isDossiersOpen, setIsDossiersOpen] = useState(false);
  const [relations, setRelations] = useState({
    main: {
      label: "Relations",
      icon: "fas fa-address-book",
      defaultOpen: false,
    },
    types: [],
  });
  const [dossiers, setDossiers] = useState({
    main: { label: "Dossiers", icon: "fas fa-folder", defaultOpen: false },
    types: [],
  });

  // Relations (Firestore)
  useEffect(() => {
    if (!user?.uid) {
      setRelations((r) => ({ ...r, types: [] }));
      setIsRelationsOpen(false);
      return;
    }
    (async () => {
      const app = await ensureAppSettings(user.uid);
      const data = app?.relations || { types: [], fields: [], main: {} };
      const merged = {
        main: {
          label: data?.main?.label ?? "Relations",
          icon: data?.main?.icon ?? "fas fa-address-book",
          defaultOpen: !!data?.main?.defaultOpen,
        },
        types: Array.isArray(data?.types) ? data.types : [],
      };
      //console.log("[search] Sidebar relations chargées:", merged);
      setRelations(merged);
      setIsRelationsOpen(
        !!merged.main.defaultOpen ||
          merged.types.some((t) => t.key === currentPage)
      );
    })();
  }, [user?.uid, currentPage]);
  // Dossiers (Firestore)
  useEffect(() => {
    if (!user?.uid) {
      setDossiers((d) => ({ ...d, types: [] }));
      setIsDossiersOpen(false);
      return;
    }
    (async () => {
      const app = await ensureAppSettings(user.uid);
      const data = app?.dossiers || { types: [], fields: [], main: {} };
      const merged = {
        main: {
          label: data?.main?.label ?? "Dossiers",
          icon: data?.main?.icon ?? "fas fa-folder",
          defaultOpen: !!data?.main?.defaultOpen,
        },
        types: Array.isArray(data?.types) ? data.types : [],
      };
      //console.log("[search] Sidebar dossiers chargés:", merged);
      setDossiers(merged);
      setIsDossiersOpen(
        !!merged.main.defaultOpen ||
          merged.types.some((t) => t.key === currentPage)
      );
    })();
  }, [user?.uid, currentPage]);

  // Ouvre l'accordéon si la page courante correspond à un type
  useEffect(() => {
    if (relations.types.some((t) => t.key === currentPage))
      setIsRelationsOpen(true);
    if (dossiers.types.some((t) => t.key === currentPage))
      setIsDossiersOpen(true);
  }, [currentPage, relations.types, dossiers.types]);

  const handleRelationClick = (e) => {
    e.preventDefault();
    setIsRelationsOpen((v) => !v);
  };

  const handleDossierClick = (e) => {
    e.preventDefault();
    setIsDossiersOpen((v) => !v);
  };

  return (
    <aside className={`sidebar ${open ? "open" : ""}`}>
      <div className="sidebar-section">
        <ul className="sidebar-menu">
          <li className="menu-item">
            <a
              href="#"
              className={`sidebar-link ${
                currentPage === "dashboard" ? "active" : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                console.log("[search] Sidebar: Clicking dashboard");
                onNavigate("dashboard");
              }}
            >
              <i className="fas fa-home"></i>
              <span>Tableau de bord</span>

              {/* Icône éditer (ouvre la page de config du dashboard) */}
              <i
                className="fas fa-edit sidebar-edit-icon"
                title="Configurer le tableau de bord"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  // console.log('[search] Sidebar: Clicking editDashboard');
                  onNavigate("editDashboard");
                }}
              />
            </a>
          </li>
        </ul>
      </div>

      <div className="sidebar-section">
        <h3 className="sidebar-title">Espace de travail</h3>
        <ul className="sidebar-menu">
          <li className="sidebar-item">
            <a
              href="#"
              className={`sidebar-link ${
                currentPage === "models" ? "active" : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                console.log("[search] Sidebar: Clicking models");
                onNavigate("models");
              }}
            >
              <i className="fas fa-layer-group"></i>
              <span>Modèles</span>
            </a>
          </li>



          {/* Relations avec sous-menu dynamique */}
          <li className="sidebar-item">
            <div className="sidebar-link-container">
              <a
                href="#"
                className={`sidebar-link ${
                  relations.types.some((t) => t.key === currentPage)
                    ? "active"
                    : ""
                }`}
                onClick={handleRelationClick}
              >
                <i className={relations.main.icon}></i>
                <span>{relations.main.label}</span>

                {/* Icône éditer (ouvre la page de config) */}
                <i
                  className="fas fa-edit sidebar-edit-icon"
                  title="Configurer Relations"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    //console.log('[search] Sidebar: Clicking editRelations')
                    onNavigate("editRelations");
                  }}
                  style={{
                    marginLeft: "auto",
                    marginRight: 8,
                    cursor: "pointer",
                  }}
                ></i>

                <i
                  className={`fas fa-chevron-${
                    isRelationsOpen ? "up" : "down"
                  } sidebar-arrow`}
                ></i>
              </a>
            </div>

            <ul className={`submenu ${isRelationsOpen ? "open" : ""}`}>
              {relations.types
                .filter((t) => t.visible !== false)
                // AJOUT : trier par "order" avant affichage
                .sort(
                  (a, b) =>
                    (a.order ?? 0) - (b.order ?? 0) ||
                    a.label.localeCompare(b.label)
                )
                .map((t) => (
                  <li key={t.key} className="submenu-item">
                    <a
                      href="#"
                      className={`submenu-link ${
                        currentPage === t.key ? "active" : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        console.log(
                          "[search] Sidebar: Clicking relation",
                          t.key
                        );
                        onNavigate(t.key);
                      }}
                    >
                      <i className={t.icon}></i>
                      <span>{t.label}</span>
                    </a>
                  </li>
                ))}
            </ul>
          </li>

          {/* Dossiers avec sous-menu dynamique */}
          <li className="sidebar-item">
            <div className="sidebar-link-container">
              <a
                href="#"
                className={`sidebar-link ${
                  dossiers.types.some((t) => t.key === currentPage)
                    ? "active"
                    : ""
                }`}
                onClick={handleDossierClick}
              >
                <i className={dossiers.main.icon}></i>
                <span>{dossiers.main.label}</span>

                {/* Icône éditer (ouvre la page de config) */}
                <i
                  className="fas fa-edit sidebar-edit-icon"
                  title="Configurer Dossiers"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    console.log("[search] Sidebar: Clicking editDossiers");
                    onNavigate("editDossiers");
                  }}
                  style={{
                    marginLeft: "auto",
                    marginRight: 8,
                    cursor: "pointer",
                  }}
                ></i>

                <i
                  className={`fas fa-chevron-${
                    isDossiersOpen ? "up" : "down"
                  } sidebar-arrow`}
                ></i>
              </a>
            </div>

            <ul className={`submenu ${isDossiersOpen ? "open" : ""}`}>
              {dossiers.types
                .filter((t) => t.visible !== false)
                // AJOUT : trier par "order" avant affichage
                .sort(
                  (a, b) =>
                    (a.order ?? 0) - (b.order ?? 0) ||
                    a.label.localeCompare(b.label)
                )
                .map((t) => (
                  <li key={t.key} className="submenu-item">
                    <a
                      href="#"
                      className={`submenu-link ${
                        currentPage === t.key ? "active" : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        console.log(
                          "[search] Sidebar: Clicking dossier",
                          t.key
                        );
                        onNavigate(t.key);
                      }}
                    >
                      <i className={t.icon}></i>
                      <span>{t.label}</span>
                    </a>
                  </li>
                ))}
            </ul>
          </li>
        </ul>
      </div>

      <div className="sidebar-section">
        <h3 className="sidebar-title">Administration</h3>
        <ul className="sidebar-menu">
          <li className="sidebar-item">
            <a
              href="#"
              className="sidebar-link"
              onClick={(e) => e.preventDefault()}
            >
              <i className="fas fa-chart-bar"></i>
              <span>Statistiques</span>
            </a>
          </li>
          <li className="sidebar-item">
            <a
              href="#"
              className={`sidebar-link ${
                currentPage === "teams" ? "active" : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                onNavigate("teams");
              }}
            >
              <i className="fas fa-users-cog"></i>
              <span>Équipe</span>
            </a>
          </li>
          {/* Marketplace */}
          <li className="sidebar-item">
            <a
              href="#"
              className={`sidebar-link ${
                currentPage === "marketplaceManage" ? "active" : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                onNavigate("marketplaceManage");
              }}
            >
              <i className="fas fa-store"></i>
              <span>Publications</span>
            </a>
          </li>
          <li className="sidebar-item">
            <a
              href="#"
              className="sidebar-link"
              onClick={(e) => e.preventDefault()}
            >
              <i className="fas fa-cog"></i>
              <span>Paramètres</span>
            </a>
          </li>
        </ul>
      </div>
    </aside>
  );
}
